var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    "data-name": "Group 44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M727.279,226.981l-4.726-.011v-1.236a1.6,1.6,0,0,0-1.6-1.6h-3.121a1.6,1.6,0,0,0-1.6,1.6v.474c0,.241-.006.544-.013.755l-4.606.016a.671.671,0,0,0-.669.669v.235a.671.671,0,0,0,.669.669h15.664a.67.67,0,0,0,.669-.669v-.236A.671.671,0,0,0,727.279,226.981ZM721,225.891v.883a.187.187,0,0,1-.186.187h-2.748a.187.187,0,0,1-.187-.187v-.883a.187.187,0,0,1,.187-.187h2.748A.187.187,0,0,1,721,225.891Z",
    "data-name": "Path 94",
    transform: "translate(-703.447 -218.136)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.553,228.71l-.591-.052a.439.439,0,0,0-.314.1.416.416,0,0,0-.138.206L723.387,241.5c-.05.792-.415.792-.535.792l-7.1.021c-.4-.031-.445-.7-.446-.717l-1.15-12.506A.429.429,0,0,0,714,228.8a.4.4,0,0,0-.319-.1l-.592.053a.425.425,0,0,0-.293.148.433.433,0,0,0-.1.319l1.156,13.064a1.494,1.494,0,0,0,1.444,1.529l8.045-.034a1.214,1.214,0,0,0,.844-.281,2.02,2.02,0,0,0,.619-1.461l1.137-12.851A.434.434,0,0,0,725.553,228.71Z",
    "data-name": "Path 95",
    transform: "translate(-703.319 -217.807)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.029,240.539a.536.536,0,0,0,.073,0,.642.642,0,0,0,.567-.711l-1.051-9.251a.643.643,0,1,0-1.278.144l1.05,9.251A.644.644,0,0,0,717.029,240.539Z",
    "data-name": "Path 96",
    transform: "translate(-703.127 -217.709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.632,239.895v-9.251a.643.643,0,1,0-1.286,0v9.251a.643.643,0,1,0,1.286,0Z",
    "data-name": "Path 97",
    transform: "translate(-702.908 -217.709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.017,240.539a.643.643,0,0,0,.639-.582l.891-9.251a.646.646,0,0,0-.579-.7.653.653,0,0,0-.7.579l-.89,9.251a.645.645,0,0,0,.579.7Z",
    "data-name": "Path 98",
    transform: "translate(-702.76 -217.709)"
  }))));
};
export default SvgTrash;